import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Toggle from 'react-toggle';
import moment from 'moment';
import isEmpty from 'lodash/isEmpty';
import styles from '../shared/styles';
import Coupons from './coupons';
import { RowDivision, DivisionLabel, Select } from '../shared/styled-components';
import { canUserAccessFeature } from '../../../../helpers/userinfoHelper';
import { HigherPlanTag } from '../../../../styles/styled';
import { ALERTS } from '../../../../helpers/texts';
const {
  currencies,
  convertDecimalCommasToDots,
  isProduction,
} = require('../../../../../server/scripts/utils.js')();

class Pricing extends Component {
  constructor(props) {
    super(props);

    this.addPriceOption = this.addPriceOption.bind(this);
    this.addCoupon = this.addCoupon.bind(this);
    this.handlePriceInputs = this.handlePriceInputs.bind(this);
    this.deletePriceOption = this.deletePriceOption.bind(this);
  }

  handlePriceInputs(idx) {
    return e => {
      let pricePropvalue = e.target.value;
      const pricePropkey = e.target.name;
      const { prices, onPricesUpdate } = this.props;

      if (prices[idx] && !isEmpty(pricePropkey)) {
        // for prices allow commas and dots for decimals
        if (pricePropkey === 'price') {
          pricePropvalue = convertDecimalCommasToDots(pricePropvalue);
        }

        prices[idx][pricePropkey] = pricePropvalue;

        if (pricePropkey === 'billingCycle' && !isEmpty(prices[idx].coupons)) {
          prices[idx].coupons = [...prices[idx].coupons].map(coupon => {
            coupon.couponType = 'discount';
            return coupon;
          });
        }

        onPricesUpdate(prices);
      }
    };
  }

  deletePriceOption(idx) {
    return () => {
      let { prices, onPricesUpdate } = this.props;
      if (prices.length > 1) {
        prices.splice(idx, 1);
      } else {
        prices[0] = {
          paymentPlan: '',
          billingCycle: 'monthly',
          price: '',
          currency: 'USD',
        };
      }

      onPricesUpdate(prices);
    };
  }

  addCoupon(priceIndex) {
    return () => {
      const { prices, onPricesUpdate, showModal } = this.props;
      const isAllowedCoupon = canUserAccessFeature('SOUNDCAST_COUPONS');
      if (!isAllowedCoupon) {
        return showModal({
          title: 'Upgrade Required',
          content: ALERTS().SOUNDCAST_COUPONS.NO_ACCESS,
          upgrade: true,
        });
      }

      if (!prices[priceIndex].coupons) {
        prices[priceIndex].coupons = [];
      }

      prices[priceIndex].coupons.push({
        code: '',
        percentOff: 0,
        couponType: 'discount',
        expiration: moment().add(3, 'months').unix(),
      });

      // update prices
      onPricesUpdate(prices);
    };
  }

  addPriceOption() {
    const { prices, onPricesUpdate, showModal } = this.props;
    const allowedAddMore = prices.length > 0 && canUserAccessFeature('SOUNDCAST_MULTIPLE_PRICING');
    if (!allowedAddMore) {
      return showModal({
        title: 'Upgrade Required',
        content: ALERTS().SOUNDCAST_MULTIPLE_PRICING.NO_ACCESS,
        upgrade: true,
      });
    }

    prices.push({
      paymentPlan: '',
      billingCycle: 'monthly',
      price: 1,
      currency: 'USD',
    });

    // update prices
    onPricesUpdate(prices);
  }

  renderAddCouponBtn({ price }, priceIndex) {
    const priceTag = price === 'free' ? 0 : price;
    const isAllowedCoupon = canUserAccessFeature('SOUNDCAST_COUPONS');

    if (priceTag <= 0) {
      return null;
    }

    return (
      <>
        <div style={styles.couponButton}>
          <div onClick={this.addCoupon(priceIndex)}>Add a coupon</div>
        </div>
        {!isAllowedCoupon && <HigherPlanTag className="margin-one-left" />}
      </>
    );
  }

  renderAddPriceOptionBtn() {
    const { prices } = this.props;
    const allowedAddMore = prices.length > 0 && canUserAccessFeature('SOUNDCAST_MULTIPLE_PRICING');

    return (
      <>
        <div
          onClick={this.addPriceOption}
          style={{
            ...styles.addFeatureButton,
            display: 'inline-block',
          }}>
          Add another price option
        </div>
        {!allowedAddMore && <HigherPlanTag className="margin-one-left" />}
      </>
    );
  }

  render() {
    const {
      public: isPublic,
      forsale,
      prices,
      soundcastId,
      onEnableCharge,
      onPricesUpdate,
    } = this.props;

    if (!isPublic) {
      return null;
    }

    return (
      <RowDivision className="row">
        <div id="pricing" className="col-lg-9 col-md-9 col-sm-12 col-xs-12">
          <DivisionLabel>Pricing</DivisionLabel>
          <div>
            <div id="charge-toggle" style={styles.toggleStatus}>
              <Toggle
                className="toggle-green"
                id="charging-status"
                aria-labelledby="charging-label"
                checked={forsale}
                onChange={onEnableCharge}
              />
              <span id="share-label" style={styles.toggleStatusLabel}>
                Charge for this soundcast
              </span>
            </div>
            {forsale && (
              <React.Fragment>
                {prices.map((price, i) => {
                  const priceTag = price.price == 'free' ? 0 : price.price;
                  const priceCurrency = 'currency' in prices[i] ? prices[i].currency : 'USD';
                  return (
                    <div key={`price-tag-${i}`} style={{ margin: '10px 0' }}>
                      <div className="row">
                        <div className="plan-name col-lg-5 col-sm-12">
                          <span>
                            <strong>Payment Plan Name</strong>
                          </span>
                          <div style={{ display: 'flex' }}>
                            <div style={styles.multipleInputLeft}>{`${i + 1}`}</div>
                            <input
                              type="text"
                              style={styles.multipleInputCenter}
                              name="paymentPlan"
                              size="4"
                              placeholder="e.g. 3 day access, monthly subscription, etc"
                              onChange={this.handlePriceInputs(i)}
                              value={prices[i].paymentPlan}
                            />
                          </div>
                        </div>
                        <div className="plan-billing col-lg-3 col-sm-12">
                          <span>
                            <strong>Billing</strong>
                          </span>
                          <Select
                            type="text"
                            style={styles.multipleInputCenter}
                            name="billingCycle"
                            onChange={this.handlePriceInputs(i)}
                            value={prices[i].billingCycle}>
                            <option value="one time">one time purchase</option>
                            <option value="rental">one time rental</option>
                            <option value="monthly">monthly subscription</option>
                            <option value="quarterly">quarterly subscription</option>
                            <option value="annual">annual subscription</option>
                            {!isProduction() && (<option value="dev1daily">1 day subscription (dev test1)</option>)}
                            {!isProduction() && (<option value="dev2daily">2 day subscription (dev test2)</option>)}
                          </Select>
                        </div>
                        <div className="plan-price col-lg-3 col-sm-12">
                          <span>
                            <strong>Price</strong>
                          </span>
                          <div style={{ display: 'flex' }}>
                            <input
                              type="text"
                              style={styles.multipleInputCenter}
                              name="price"
                              placeholder={''}
                              onChange={this.handlePriceInputs(i)}
                              value={priceTag}
                            />
                            <Select
                              type="text"
                              style={styles.multipleInputCenter}
                              name="currency"
                              onChange={this.handlePriceInputs(i)}
                              value={priceCurrency}>
                              {currencies.map(([code, text]) => (
                                <option
                                  key={`currency-${code}`}
                                  value={code}>{`(${code}) ${text}`}</option>
                              ))}
                            </Select>
                          </div>
                        </div>
                        <div className="col-lg-1 col-sm-12">
                          <div>&nbsp;</div>
                          <div
                            style={{
                              ...styles.multipleInputRight,
                              cursor: 'pointer',
                              textAlign: 'center',
                              borderLeft: '1px solid #e5e5e5',
                            }}
                            onClick={this.deletePriceOption(i)}>
                            <i className="fa fa-times " aria-hidden="true" />
                          </div>
                        </div>
                      </div>

                      {prices[i].billingCycle === 'rental' && (
                        <div className="col-md-12" style={{ marginTop: 10 }}>
                          <div className="col-md-4 col-md-offset-6" style={{ marginRight: 10 }}>
                            <span>Rental period</span>
                            <div>
                              <input
                                type="text"
                                style={{ ...styles.inputTitle, width: '70%' }}
                                name="rentalPeriod"
                                placeholder={'2'}
                                onChange={this.handlePriceInputs(i)}
                                value={prices[i].rentalPeriod}
                              />
                              <span style={{ fontSize: 18 }}>{` days`}</span>
                            </div>
                          </div>
                        </div>
                      )}
                      {price.coupons && (
                        <Coupons
                          price={price}
                          priceIndex={i}
                          prices={prices}
                          onChange={onPricesUpdate}
                          soundcastId={soundcastId}
                        />
                      )}
                      {this.renderAddCouponBtn(price, i)}
                    </div>
                  );
                })}
                {this.renderAddPriceOptionBtn()}
              </React.Fragment>
            )}
          </div>
        </div>
      </RowDivision>
    );
  }
}

Pricing.propTypes = {
  public: PropTypes.bool,
  forsale: PropTypes.bool,
  prices: PropTypes.array,
  onEnableCharge: PropTypes.func,
  onPricesUpdate: PropTypes.func,
  showModal: PropTypes.func,
};

Pricing.defaultProps = {
  public: false,
  forsale: false,
  prices: [],
  onEnableCharge: () => {},
  onPricesUpdate: () => {},
  showModal: () => {},
};

export default Pricing;
